export const red = "#be1931";
export const green1 = "#39ec8c";
export const green2 = "#39b54a";
export const green3 = "#21a34b";
export const green4 = "#015c2c";
export const green5 = "#012813";
export const blue = "#0ca6ff";
export const darkBlue = "#003554";
export const gold = "#FEDF61";
export const darkerGold = "#FFCE0F";
export const greenGradient = "linear-gradient(90deg, #31dd80 0%, #53ff64 100%)";
export const Color = {
    red,
    green1,
    green2,
    green3,
    green4,
    green5,
    blue,
    darkBlue,
    gold,
    darkerGold,
    greenGradient,
};
